import { createSelector } from '@ngrx/store';

import { getBaseState } from '../reducers';
import { MessengerState } from './messenger.reducer';

export const getMessengerState = createSelector(
  getBaseState,
  state => state.messenger
);

export const getConversationList = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationList
);

export const getConversationListPage = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationListPage
);

export const getConversationListActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationListActionState
);

export const getActiveConversationId = createSelector(
  getMessengerState,
  (state: MessengerState) => state.activeConversation
);

export const getActiveConversation = createSelector(
  getActiveConversationId,
  getConversationList,
  (conversationId, conversations) =>
    conversations.find(conversation => conversation.id === conversationId)
);

export const getConversationMessagesPage = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationMessagesPage
);

export const getConversationDetails = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationDetails
);

export const getConversationMessages = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationMessages
);

export const getSender = createSelector(
  getMessengerState,
  (state: MessengerState) => state.sender
);

export const getConversationMessagesCount = createSelector(
  getConversationList,
  conversations =>
    conversations &&
    conversations
      .filter(c => c && c.unreadMessages > 0)
      .reduce((sum, curr) => sum + curr.unreadMessages, 0)
);

export const getConversationMessagesAttach = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationMessagesAttach
);

export const getConversationMessagesActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationMessagesActionState
);

export const getConversationDetailsActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.conversationDetailsActionState
);

export const getBulkSendMessageActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.bulkSendMessageActionState
);

export const getUnreadMessageCount = createSelector(
  getMessengerState,
  (state: MessengerState) => state.countUnread
);

export const getMessageCount = createSelector(
  getConversationMessages,
  messages => {
    return messages ? messages.filter(message => message.read).length : 0;
  }
);

export const getParticipatedAgents = createSelector(
  getMessengerState,
  (state: MessengerState) => state.participatedAgents
);

export const getParticipatedAgentsActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.participatedAgentsActionState
);

export const getMessageTemplates = createSelector(
  getMessengerState,
  (state: MessengerState) => state.loadedTemplate
);

export const getMessageTemplatesActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.loadedTemplateActionState
);

export const getMessageTemplatesPage = createSelector(
  getMessengerState,
  (state: MessengerState) => state.loadedTemplatePage
);

export const getParsedMessageTemplates = createSelector(
  getMessengerState,
  (state: MessengerState) => state.loadedParsedTemplates
);

export const getParsedMessageTemplatesActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.loadedParsedTemplatesActionState
);

export const getParsedMessageTemplatesPage = createSelector(
  getMessengerState,
  (state: MessengerState) => state.loadedParsedTemplatesPage
);

export const getCreateTemplateActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.createTemplateActionState
);

export const getUpdateTemplateActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.updateTemplateActionState
);

export const getDeleteTemplateActionState = createSelector(
  getMessengerState,
  (state: MessengerState) => state.deleteTemplateActionState
);

export const getConversationArchived = createSelector(
  getMessengerState,
  (state: MessengerState) => state.archivedByCustomer
);

export const getSearchedProperty = createSelector(
  getMessengerState,
  (state: MessengerState) => state.searchedProperty
);
